import React from 'react';

import type { NamedCollection, UncollectedCollection } from 'domains/photos';

type CollectionPickerProps = {
  onChange: (name: string) => void;
  collections: NamedCollection[];
  uncollected: UncollectedCollection;
  pending?: string;
  selected?: string;
};

function CollectionPicker({
  onChange,
  collections,
  uncollected,
  pending,
  selected,
}: CollectionPickerProps) {
  return (
    <div id="collection_picker_container" className="collection-picker embedded">
      <div id="collection_picker_wrapper">
        <label htmlFor="collection-picker-select" className="cp-label">
          Upload to Collection: {pending || selected || 'Uncollected'}
        </label>
        {!pending && (
          <div className="cp-inputs">
            <select
              id="collection-picker-select"
              className="cp-select-list untitled-coll"
              value={selected}
              onChange={(e) => onChange(e.target.value)}
            >
              {[...collections, uncollected].map((collection) => (
                <option
                  key={`${collection.name}${collection.count}`}
                  value={collection.name || ''}
                  className={collection.count === 0 ? 'untitled-coll' : ''}
                >
                  {collection.name || 'Uncollected'} (
                  {`${collection.count} image${collection.count !== 1 ? 's' : ''}`})
                </option>
              ))}
            </select>
          </div>
        )}
      </div>
    </div>
  );
}

export default CollectionPicker;
